import React from 'react';

import adminIcon from '../assets/admin-icon.png';
import { getFriendlyUserStatus } from '../component/ProviderUserForm/component/UserStatus';
import { UserManagementColumns } from './types';

export const VISIBLE_FIELDS: UserManagementColumns = [
    { name: 'firstName', label: 'First Name' },
    { name: 'lastName', label: 'Last Name' },
    { name: 'email', label: 'Email' },
    {
        name: 'status', label: 'Status', isUnsortable: true,
        render(status: string) {
            return getFriendlyUserStatus(status);
        }
    },
    {
        name: 'userManagementAdminAccess', label: 'Admin', isUnsortable: true,
        maxWidth: '100px',
        render(isAdmin: boolean) {
            if (isAdmin) {
                return (
                    <img className="um-admin-icon" src={ adminIcon } alt="admin-status"/>
                );
            } else {
                return '';
            }
        }
    },
];
